import { Button } from "reactstrap";
import styles from "./components.module.scss";

const ButtonComponent: React.FC<{ disable: boolean; buttonText: string; save: boolean; buttonType: any; onClick?: any }> = props => {
  return (
    <>
      {props.save ? (
        <Button onClick={props.onClick} outline color="success" className={styles["submit"]} disabled={props.disable} type={props.buttonType}>
          {props.buttonText}
        </Button>
      ) : (
        <Button onClick={props.onClick} className={styles["cancel"]} type={props.buttonType} disabled={props.disable}>
          {props.buttonText}
        </Button>
      )}
    </>
  );
};
export default ButtonComponent;
